export default __webpack_public_path__ + "static/media/check-btn.416ec360.webp";